<template>
	<div class="zhaopin">
		<div class="zhaopin-top">
			<img src="../../static/img/zhaopin.png"/>
		</div>
		<div class="zhaopin-choose">
			<div class="choose-top">
				<div class="com-top-top">
					<ul>
						<li v-for="sel in choose" class="casenav" v-bind:class="{caseacli : selid == sel.Tabtit}" @click="selclick(sel.Tabtit)">{{sel.Tabtit}}</li>
					</ul>
				</div>
			</div>
			<div class="choose-center">
				<transition name="zhaopin-fade">
				<div class="center-detail" >
					<ul v-for="cen in zhiwei" v-show="selid == cen.department"> 
						<li v-bind:class="{liactivecon : cen.ID == liid}" @click="liclick(cen.ID)" > 
							<div class="center-line"></div>
							<b>{{cen.type}}</b>
							<span class="det-sta">
								薪资 ： {{cen.money}}  &nbsp;&nbsp;&nbsp;&nbsp; 招聘状态 ： {{cen.status}} &nbsp;&nbsp;&nbsp;&nbsp; 招聘人数 ： {{cen.persons}}
							</span>
							<span class="right glyphicon" v-bind:class="{'glyphicon-triangle-bottom' : cen.ID == liid}"></span>
							<span class="right glyphicon" v-bind:class="{'glyphicon-triangle-right' : cen.ID != liid}"></span>
						</li>
						<transition name="zhaopin-fade">
						<div class="det-content" v-show="cen.ID == liid">
							<div v-html="cen.demand">
								{{cen.demand}}
							</div>
							
						</div>
						</transition>
					</ul>
				</div>
				</transition>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		name : 'zhaopin',
		data(){
			return{
				choose :[],
				selid : '',
				liid : 0,
				zhiwei :[],
			}
		},
		mounted(){
				this.getzhaopin();
				 },
		methods :{
			liclick(id){
				if(this.liid == id ){
					this.liid = -1
				}else{
					
					this.liid = id
				}
				
			},
			getzhaopin(){
				var taball = [];
				this.$http.post('http://www.gd-sc.net:9094',{table : 'Tabtit'},{emulateJSON: true}).then((response) => {
			        for(var i = 0; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Remark == 'Tabtitj'){
			        		taball.push(response.body.recordset[i])
			        	}
			        }
			        this.selid = taball[0].Tabtit;
			        this.choose = taball;
			      })
				this.$http.post('http://www.gd-sc.net:9094',{table : 'job'},{emulateJSON: true}).then((response) => {
			        for(var i=0 ; i<response.body.recordset.length ; i++){
			        }
			        this.zhiwei = response.body.recordset;
			      })
			},
			selclick(id){
				this.selid = id
			}
		},
	}
</script>

<style>
	.zhaopin{
		width: 100%;
		position: relative;
		clear: both;
	}
	.zhaopin-top{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.zhaopin-top img {
		width: 100%;
	}
	.zhaopin-choose{
		position: relative;
		clear: both;
		width: 80%;
		padding: 60px 0;
		margin: 0 auto;
	}
	.choose-top{
		position: relative;
		width: 70%;
		clear: both;
		margin: 0 auto 50px;
	}
	.top-sel{
		position: relative;
		width: 25%;
		display: inline-block;
		clear: both;
	}
	.case .com-top-top{
		width: 100%;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
		border-bottom: none;
	}
	.com-top-top li.casenav{
		display: inline-block;
		width: 12%;
		padding: 10px;
		margin-right: 2px;
		color: #666;
		transition: .2s all;
	}
	
	.com-top-top li.casenav:hover{
	    transform: scale(1.05);
	    background: #f1c2c2 !important;
	    color: #da251c !important;
	}
	
	.com-top-top li.caseacli{
		color: #fff;
    	background: #da251c;
	}
	.case .com-top-top ul{
		width: 100%;
		margin: 0 auto;
		text-align: center;
	}
	.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.top-sel img{
		width: 50%;
		position: relative;
	}
	.choose-center{
		position: relative;
		width: 100%;
	}
	.choose-top p{
		margin-top: 30px;
		font-size: 17px;
	}
	.choose-top p.activep{
		color: #e01313 !important;
	}
	.choose-center li{
		padding: 15px 0;
		text-align: left;
		list-style: none;
		position: relative;
		border-bottom: 1px solid #d7d7d7;
	}
	.choose-center li.liactivecon{
		background: #f1f1f1;
		border-top: 3px solid #d7d7d7;
	}
	.choose-center li b{
		font-size: 16px;
		position: relative;
		left: 40px;
		padding: 0 20px;
		display: inline-block;
	}
	.center-line{
		background: #e01313;
		width: 20px;
		height: 3px;
		position: absolute;
		top: 23px;
		left: 20px;
	}
	.choose-center span.det-sta{
		display: inline-block;
		margin-left: 50px;
	}
	.choose-center span.glyphicon-triangle-bottom{
		color: #666666 !important;
	}
	.choose-center span.glyphicon{
		position: absolute;
		top: 18px;
		right: 20px;
		color: #bbbbbb;
	}
	.det-content{
		position: relative;
		clear: both;
		text-align: left;
		margin: 40px 20px;
	}
	.det-content p{
		line-height: 20px;
		margin: 30px 0;
		color: #555555;
	}
	.zhaopin-fade-enter-active {
	  transition: all .3s ease;
	}
	.zhaopin-fade-leave-active {
	  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.zhaopin-fade-enter, .zhaopin-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	  transform: translateY(30px);
	  opacity: 0;
	}
	.center-detail{
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/recruit.vue